import { Form } from 'antd';
import React from 'react';
import styles from './FormTransport.module.scss';
import DropdownSelect from '../../../dropdownSelect';
import useTransportCountries from '../../api/query/useTransportCountries';
import useTransportTypes from '../../api/query/useTransportTypes';
import { getRenderControl } from '../../../SingleControlCustom/getRenderControl';
import DispexInput from '../../../DispexInput';
import { getOptionsSelect } from '../../lib/getOptionsSelect';
import ClientAddresseRow from '../ClientAddresseRow/ClientAddresseRow';
import TransportDocuments from '../../../TransportDocuments/TransportDocuments';
import Attachments from '../Attachments/Attachments';

const FormTransport = ({
  form,
  isEdit,
  companyId,
  transport,
  addFromPermit,
  valueForTs,
}) => {
  const { data: countries = [], isFetching: isCountriesFetching } =
    useTransportCountries({ staleTime: Infinity });

  const { data: transportTypes = [], isFetching: isFetchingTypes } =
    useTransportTypes();

  const hasVisibleAddresses = !!(!isEdit && companyId);

  return (
    <div className={styles.root}>
      {hasVisibleAddresses && (
        <ClientAddresseRow
          form={form}
          companyId={companyId}
          addFromPermit={addFromPermit}
          valueForTs={valueForTs}
        />
      )}
      <div className={styles.row}>
        <Form.Item
          label="Страна"
          style={{ flex: 1 }}
        >
          {form.getFieldDecorator('countryId', {
            initialValue: isEdit ? transport?.country?.id : countries[0]?.id,
            rules: [{ required: true, message: 'Страна не выбрана' }],
          })(
            <DropdownSelect
              multiple={false}
              options={getOptionsSelect({ data: countries })}
              renderControl={getRenderControl({
                options: getOptionsSelect({ data: countries }),
                isClear: false,
                value: form.getFieldValue('countryId'),
                disabled: isCountriesFetching || isEdit,
                loading: isCountriesFetching,
                placeholder: 'Россия',
              })}
            />
          )}
        </Form.Item>
        <Form.Item
          label="Тип ТС"
          style={{ flex: 1 }}
        >
          {form.getFieldDecorator('transportTypeId', {
            initialValue: isEdit ? transport?.transportType?.id : undefined,
            rules: [{ required: true, message: 'Тип ТС не указан' }],
          })(
            <DropdownSelect
              multiple={false}
              options={getOptionsSelect({ data: transportTypes })}
              renderControl={getRenderControl({
                options: getOptionsSelect({ data: transportTypes }),
                isClear: false,
                value: form.getFieldValue('transportTypeId'),
                disabled: isFetchingTypes || isEdit,
                loading: isFetchingTypes,
                placeholder: 'Тип ТС',
              })}
            />
          )}
        </Form.Item>
        <Form.Item
          label="Номер"
          style={{ flex: 1 }}
        >
          {form.getFieldDecorator('number', {
            initialValue: isEdit ? transport?.number : undefined,
            rules: [
              {
                required: true,
                message: 'Номер не указан',
              },
              ...(form.getFieldValue('transportTypeId') === 1
                ? [
                    {
                      pattern: /^[АВЕКМНОРСТУХD]{1}\d{3}[АВЕКМНОРСТУХD]{2}$/,
                      message: 'Номер должен быть в формате: А123ВЕ',
                    },
                  ]
                : [
                    {
                      pattern: /^\d{4}[А-Я]{2}$/,
                      message: 'Номер должен быть в формате: 1234ВЕ',
                    },
                  ]),
            ],
            normalize: (value = '') =>
              value.toUpperCase().replace(/[^АВЕКМНОРСТУХD0-9]/g, ''),
          })(
            <DispexInput
              type="text"
              placeholder={
                form.getFieldValue('transportTypeId') === 1
                  ? 'А123ВЕ'
                  : '1234ВЕ'
              }
              maxLength={6}
              autoComplete="off"
              spellCheck={false}
              style={{ height: '40px' }}
              disabled={isEdit || !form.getFieldValue('transportTypeId')}
            />
          )}
        </Form.Item>
        <Form.Item
          label="Регион"
          style={{ flex: 1 }}
        >
          {form.getFieldDecorator('region', {
            initialValue: isEdit ? transport?.region : undefined,
            rules: [
              { required: true, message: 'Регион не указан' },
              {
                pattern: /^[0-9]{2,3}$/,
                message: 'Регион должен быть в формате: 197',
              },
            ],
          })(
            <DispexInput
              placeholder="197"
              maxLength={3}
              style={{ height: '40px' }}
              disabled={isEdit}
            />
          )}
        </Form.Item>
      </div>
      <div className={styles.row}>
        <Form.Item
          label="Марка"
          style={{ flex: 1, margin: 0, alignSelf: 'start' }}
        >
          {form.getFieldDecorator('brand', {
            initialValue: isEdit ? transport?.brand : undefined,
            rules: [{ required: true, message: 'Марка не указана' }],
          })(
            <DispexInput
              placeholder="BMW"
              style={{ height: '40px' }}
            />
          )}
        </Form.Item>
        <Form.Item
          label="Модель"
          style={{ flex: 1, margin: 0, alignSelf: 'start' }}
        >
          {form.getFieldDecorator('model', {
            initialValue: isEdit ? transport?.model : undefined,
            rules: [{ required: true, message: 'Модель не указана' }],
          })(
            <DispexInput
              placeholder="X5 2019"
              style={{ height: '40px' }}
            />
          )}
        </Form.Item>
        {isEdit ? (
          <TransportDocuments
            transportId={transport?.id}
            zIndex={99999}
            style={{ alignSelf: 'end' }}
          />
        ) : (
          <Attachments form={form} />
        )}
      </div>
    </div>
  );
};

export default FormTransport;
